import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Card from '../shared/Card.svelte';
import { getStorageSummary } from '../../lib/services/storage';
import { getSettings, updateSettings } from '../../lib/stores/settings.svelte.ts';
import { getActiveChild } from '../../lib/stores/children.svelte.ts';
import { formatVolume } from '../../lib/utils/units.ts';

var root_2 = $.from_html(`<p class="goal-reached svelte-1krzz3zu2r82s">You reached your goal! Amazing work.</p>`);
var root_1 = $.from_html(`<div class="goal-tracker svelte-1krzz3zu2r82s"><div class="goal-header svelte-1krzz3zu2r82s"><span class="goal-title svelte-1krzz3zu2r82s">Freezer Stash Goal</span> <span class="goal-value svelte-1krzz3zu2r82s"> </span></div> <div class="progress-bar svelte-1krzz3zu2r82s"><div class="progress-fill svelte-1krzz3zu2r82s"></div></div> <!></div>`);

function GoalTracker($$anchor, $$props) {
	$.push($$props, true);

	let goalMl = $.prop($$props, 'goalMl', 3, 500);
	const activeChild = $.derived(getActiveChild);
	let currentMl = $.state(0);

	$.user_effect(() => {
		if (!$.get(activeChild)) return;

		loadData();
	});

	async function loadData() {
		if (!$.get(activeChild)) return;

		const summary = await getStorageSummary($.get(activeChild).id);

		$.set(currentMl, summary.freezer + summary.deepFreezer);
	}

	const progress = $.derived(() => Math.min($.get(currentMl) / goalMl(), 1));
	const reached = $.derived(() => $.get(progress) >= 1);
	const settings = $.derived(getSettings);
	const isImperial = $.derived(() => $.get(settings).units === 'imperial');
	var fragment = $.comment();
	var node = $.first_child(fragment);

	Card(node, {
		padding: 'md',
		children: ($$anchor, $$slotProps) => {
			var div = root_1();
			var div_1 = $.child(div);
			var span = $.sibling($.child(div_1), 2);
			var text = $.child(span);

			$.reset(span);
			$.reset(div_1);

			var div_2 = $.sibling(div_1, 2);
			var div_3 = $.child(div_2);

			$.reset(div_2);

			var node_1 = $.sibling(div_2, 2);

			{
				var consequent = ($$anchor) => {
					var p = root_2();

					$.append($$anchor, p);
				};

				$.if(node_1, ($$render) => {
					if ($.get(reached)) $$render(consequent);
				});
			}

			$.reset(div);

			$.template_effect(
				($0, $1) => {
					$.set_text(text, `${$0 ?? ''} / ${$1 ?? ''}`);
					$.set_style(div_3, `width:${$.get(progress) * 100}%`);
				},
				[
					() => formatVolume($.get(currentMl), $.get(isImperial)),
					() => formatVolume(goalMl(), $.get(isImperial))
				]
			);

			$.append($$anchor, div);
		},
		$$slots: { default: true }
	});

	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	GoalTracker = $.hmr(GoalTracker);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-1krzz3zu2r82s');
		GoalTracker[$.HMR].update(module.default);
	});
}

export default GoalTracker;
import "bun-svelte:GoalTracker.svelte-1f6rjjdl0eoib-style.css";